import Icon from '@ant-design/icons';

import { ReactComponent as UnlinkIcon } from './svgs/unlink.svg';

const Unlink = props => {
  return <Icon component={UnlinkIcon} {...props} />;
};

export default Unlink;
